import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import styled from "styled-components";

import { Breadcrumb } from "antd";

import ContentList from "./components/content-list";
import ContentForms from "./components/content-forms";

export const StyledBreadcrumb = styled(Breadcrumb)`
    background: #fff;
    display: flex;
    padding: 16px 25px;
`;

const ManageContent = (): JSX.Element => {
    const match = useRouteMatch();
    return (
        <>
            <Switch>
                <Route
                    exact
                    path={`${match.path}`}
                    render={(props: any) => <ContentList {...props} />}
                />
                <Route
                    exact
                    path={`${match.path}/add`}
                    render={(props: any) => <ContentForms {...props} />}
                />
                <Route
                    exact
                    path={`${match.path}/add/:contentType`}
                    render={(props: any) => <ContentForms {...props} />}
                />
                <Route
                    path={`${match.path}/:contentType/:slug`}
                    render={(props: any) => <ContentForms {...props} />}
                />
            </Switch>
        </>
    );
};

export default ManageContent;
